import cubejs, { CubeJSApiOptions, CubejsApi } from '@cubejs-client/core';
import { CubeJsServiceOptions } from './types';
import { cubeJsStore } from './cubejsStore';
import { Store } from 'vuex';
import Vue from 'vue';
import jwt from 'jws';


const cubeJsModuleKey = 'step_cubeJs_service';
class CubeJsService {
	private apiTokenHandler!: (idCustomer: string) => Promise<string>;
	private cubeJsOptions!: CubeJSApiOptions;
	private store!: Store<any>;
	public init(serviceOptions: CubeJsServiceOptions): void {
		Vue.prototype[cubeJsModuleKey] = this;
		this.cubeJsOptions = serviceOptions.cubeJsOptions;
		this.apiTokenHandler = serviceOptions.apiTokenHandler;
		this.store = serviceOptions.store;
		this.store.registerModule(cubeJsModuleKey, cubeJsStore);
	}

	private async getToken(idCustomer: string): Promise<string> {
		let token: string | undefined = this.store.getters[`${cubeJsModuleKey}/customerToken`](idCustomer);
		if (token) {
			const decodedToken = jwt.decode(token);
			if (Date.now() < decodedToken.payload.exp * 1000)
				return token;
		}

		this.store.commit(`${cubeJsModuleKey}/loadingCubeJsTokenStart`);
		try {
			token = await this.apiTokenHandler(idCustomer);
			this.store.commit(`${cubeJsModuleKey}/loadingCubeJsTokenSuccess`);
			this.store.commit(`${cubeJsModuleKey}/setCubeJsToken`, { idCustomer, token });
			return token;
		} catch (error) {
			this.store.commit(`${cubeJsModuleKey}/loadingCubeJsTokenFailure`, error);
			throw error;
		}
	}

	async cubejsApi(idCustomer: string, options: CubeJSApiOptions | null = null): Promise<CubejsApi> {
		const token = await this.getToken(idCustomer);
		return cubejs(token, { ...this.cubeJsOptions, ...options });
	}
}

export default new CubeJsService();
